exports["BE"] = require("./BE.js");
exports["PT"] = require("./PT.js");